import api from "./api";

export function getSessionId() {
  let sid = sessionStorage.getItem("cw_sid");
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("cw_sid", sid);
  }
  return sid;
}

export function trackEvent(path, type = "pageview") {
  try {
    api
      .post("/analytics/track", {
        session_id: getSessionId(),
        path,
        referrer: document.referrer || "",
        type,
      })
      .catch(() => {});
  } catch {
    /* analytics must never break the app */
  }
}
